import React, { useCallback, useState } from 'react';
import Layout from '../Layout';
import Header from './Header';
import Body from './Body';

const StudyChat = () => {
  const headRenderer = useCallback(() => {
    return <Header />;
  }, []);

  const bodyRenderer = useCallback(() => {
    return <Body />;
  }, []);
  return (
    <Layout
      header={headRenderer}
      body={bodyRenderer}
      hasGenericFooter={true}
      gridHeaderRegionHeight="170px"
    />
  );
};

export default StudyChat;
